import { useTranslation } from "react-i18next"
import { Box, Typography } from "@mui/material"

import type { ReactNode } from "react"

import LabelValueStack from "widgets/common/LabelValueStack"

export interface SpecField {
  labelKey: string
  value: string | undefined
}

interface ConductorSpecGroupProps {
  titleKey: string
  /** Label and value rows. A group holding a table passes children instead. */
  fields?: SpecField[]
  children?: ReactNode
}

/**
 * One titled group of the conductor spec. Whether a group is worth showing at
 * all is the dialog's call, since it also places the group.
 */
const ConductorSpecGroup = ({ titleKey, fields, children }: ConductorSpecGroupProps) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="overlineDense" component="p" sx={{ mb: 2 }}>
        {t(titleKey)}
      </Typography>
      {fields?.map(({ labelKey, value }) => (
        <LabelValueStack
          key={labelKey}
          labelKey={labelKey}
          value={<Typography color="neutral.600">{value ?? "-"}</Typography>}
        />
      ))}
      {children}
    </Box>
  )
}

export default ConductorSpecGroup
